module.exports = __webpack_public_path__ + "static/img/logo48.be87ad9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo48.png
// module id = 9TnT
// module chunks = 1